<template>
  <canvas
    ref="canvas"
    @mousedown="startDrawing"
    @mousemove="draw"
    @mouseup="stopDrawing"
    @mouseleave="stopDrawing"
    @touchstart.prevent="startDrawing"
    @touchmove.prevent="draw"
    @touchend="stopDrawing"
    style="touch-action: none; display:block; width:100%; height:100%;"
  ></canvas>
</template>

<script>
export default {
  name: 'ScratchCard',
  props: {
    brushSize: { type: Number, default: 50 },
    coverImage: { type: String, default: '' },
    coverColor: { type: String, default: '#ccc' }
  },
  data() {
    return {
      ctx: null,
      isDrawing: false,
      coverLoaded: false,
      width: 0,
      height: 0
    };
  },
  mounted() {
    this.setCanvasSize();
    window.addEventListener('resize', this.setCanvasSize);
    const canvas = this.$refs.canvas;
    this.ctx = canvas.getContext('2d');
    this.drawCover();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setCanvasSize);
  },
  methods: {
    setCanvasSize() {
      const canvas = this.$refs.canvas;
      const rect = canvas.parentNode.getBoundingClientRect();
      this.width = rect.width;
      this.height = rect.height;
      canvas.width = this.width;
      canvas.height = this.height;
      this.drawCover();
    },
    drawCover() {
      if (!this.ctx) return;

      this.ctx.globalCompositeOperation = 'source-over';

      if (this.coverImage) {
        const img = new Image();
        img.src = this.coverImage;
        img.onload = () => {
          this.ctx.drawImage(img, 0, 0, this.width, this.height);
          this.coverLoaded = true;
        };
      } else {
        this.ctx.fillStyle = this.coverColor;
        this.ctx.fillRect(0, 0, this.width, this.height);
        this.coverLoaded = true;
      }
    },
    getPos(e) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      if (e.touches) {
        return { x: e.touches[0].clientX - rect.left, y: e.touches[0].clientY - rect.top };
      } else {
        return { x: e.clientX - rect.left, y: e.clientY - rect.top };
      }
    },
    startDrawing(e) {
      if (!this.coverLoaded) return;
      this.isDrawing = true;
      this.draw(e);
    },
    draw(e) {
      if (!this.isDrawing) return;
      const pos = this.getPos(e);
      this.ctx.globalCompositeOperation = 'destination-out';
      this.ctx.beginPath();
      this.ctx.arc(pos.x, pos.y, this.brushSize / 2, 0, Math.PI * 2);
      this.ctx.fill();
      this.checkComplete();
    },
    stopDrawing() {
      this.isDrawing = false;
    },
    checkComplete() {
      const imageData = this.ctx.getImageData(0, 0, this.width, this.height);
      let transparentPixels = 0;
      for (let i = 3; i < imageData.data.length; i += 4) {
        if (imageData.data[i] === 0) transparentPixels++;
      }
      if (transparentPixels / (this.width * this.height) > 0.5) {
        this.$emit('complete');
      }
    },
    reset() {
      this.drawCover(); // 重新绘制遮罩
    }
  }
};
</script>

<style scoped>
canvas {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ScratchCard.vue